<template>
    <v-container>
        <h1 class="titulo mb-3">Cadastro de Tipos de Cotas</h1>
        <v-card class="card">
            <v-card-text>
                <v-form ref="formTipoCota" @submit.prevent="sendTipoCotas">
                    <v-row>
                        <v-text-field
                                style="display:none"
                                v-model="form_data.id_tipo_cota"
                        />
                        <v-col cols="6">
                            <DynamicSelect label="Tipo da Cota:"
                                           id="TipoCotaSelect"
                                           v-model="form_data.tipo_cota"
                                           placeholder="Selecione o tipo da cota"
                                           endpoint="/dynamic-selects/tipo_cota/id"
                                           :multiple="false"
                                           class="required"
                                           :disabled="!!form_data.id_tipo_cota"
                                           :filled="!!form_data.id_tipo_cota"
                                           :rules="[$rules.hasTipoCota]"
                                           :return-object="true"
                                           item-text="label"
                                           item-value="cd_tipo_cota"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete label="Produto(s):"
                                            item-text="label"
                                            hide-selected
                                            class="required"
                                            :items="produtos"
                                            clearable
                                            chips
                                            deletable-chips
                                            :multiple="true"
                                            :return-object="true"
                                            :rules="[$rules.required]"
                                            item-value="id_produto"
                                            placeholder="Selecione os produtos"
                                            v-model="form_data.produtos_selecionados" outlined />
                        </v-col>
                    </v-row>
                    <v-row class="justify-end">
                        <v-btn class="transition mr-4" color="secondary" type="reset" @click="resetForm">Limpar</v-btn>
                        <v-btn class="transition mr-4" color="primary" type="submit">Salvar</v-btn>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
  import { get } from 'lodash'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import { notification } from '../../../plugins/helpers'
  export default {
    name: 'FormularioCadastroTipoCotas',
    props: {
      tipoCotaEdicao: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        form_data: {
          id_tipo_cota: null,
          tipo_cota: {
            id_tipo_cota: null,
            tipo_cota: null,
            cd_tipo_cota: null
          },
          produtos_selecionados: []
        }
      }
    },
    computed: {
      tipoCotaParaEditar: {
        get () {
          return this.tipoCotaEdicao
        },
        set (val) {
          this.$emit('input', val)
        }
      },
      produtos () {
        const produtos = this.$session.get('produtos').map(produto => ({ id_produto: produto.ID_Produto, cd_produto: produto.CD_Produto, nm_produto: produto.NM_Produto.toUpperCase(), label: `${produto.CD_Produto} - ${produto.NM_Produto.toUpperCase()}` }))
        return produtos.sort(this.ordenar)
      }
    },
    watch: {
      tipoCotaParaEditar (tipoCota) {
        if (tipoCota && tipoCota.id_tipo_cota) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
          this.form_data = {
            id_tipo_cota: tipoCota.id_tipo_cota,
            tipo_cota: {
              cd_tipo_cota: tipoCota.cd_tipo_cota,
              nome_tipo_cota: tipoCota.tipo_cota
            },
            produtos_selecionados: tipoCota.produtos
          }
        }
      }
    },
    methods: {
      resetForm () {
        this.resetEdicao()
        this.$refs.formTipoCota.reset()
      },
      resetEdicao () {
        this.$emit('resetEdicao')
      },
      async sendTipoCotas () {
        if (!this.$refs.formTipoCota.validate()) {
          return
        }
        const edicao = (this.tipoCotaEdicao && this.tipoCotaEdicao.id_tipo_cota > 0)
        await this.$http.post('/painel/tipo_cota', { ...this.form_data }).then((response) => {
          notification(AlertTypes.SUCCESS, `${edicao ? 'Tipo de cota atualizado' : 'Novo tipo de cota cadastrado'} com sucesso!`)
          this.$emit('registroInserido')
          this.resetForm()
        }).catch((err) => {
          const status_code = get(err, 'response.status', 500)
          if (status_code === 422) {
            notification(AlertTypes.ERROR, err)
            return
          }
          if (edicao) {
            notification(AlertTypes.ERROR, 'Tivemos um erro ao atualizar o tipo de cota, sugerimos tentar novamente e se o problema persistir entre em contato com a Área de Suporte!')
          } else {
            notification(AlertTypes.ERROR, 'Foi encontrado um erro ao finalizar o cadastro, tente novamente e caso o problema persista, entre em contato com a Área de Suporte.')
          }
          this.resetForm()
        })
      }
    }
  }
</script>
